import Aboutdes from "./Aboutdes"
import Abouthead from "./Abouthead"
import Sric from "./Sric"
import Team from "./Team"
import Navbara from "./Navbara"
import Footer from "./Footer"

const About = () => {
    return ( 
        <div id="section10">
            <Navbara />
            <Abouthead />
            <Sric />
            <Aboutdes />
            <Team />
            <Footer />
        </div>
     );
}
 
export default About;